const PIXEL_ID = '2025373898394216'

let initialized = false

declare global {
  interface Window {
    fbq?: any
    _fbq?: any
  }
}

export function initPixel() {
  if (initialized || typeof window === 'undefined')
    return // Standard Meta Pixel base code
  ;(function (f: any, b: any, e: any, v: any) {
    if (f.fbq) return
    const n: any = (f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    })
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = !0
    n.version = '2.0'
    n.queue = []
    const t = b.createElement(e)
    t.async = !0
    t.src = v
    const s = b.getElementsByTagName(e)[0]
    if (s && s.parentNode) {
      s.parentNode.insertBefore(t, s)
    } else {
      ;(b.head || b.documentElement).appendChild(t)
    }
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js',
  )

  window.fbq('init', PIXEL_ID)
  window.fbq('track', 'PageView')
  initialized = true
}

export function trackInitiateCheckout() {
  if (typeof window === 'undefined' || !window.fbq) return
  try {
    window.fbq('track', 'InitiateCheckout', {
      content_name: 'Sistema de Publicidad para Tiendas de iPhone',
      content_category: 'Guia',
      currency: 'ARS',
      value: 14900,
    })
  } catch (e) {
    // silent fail
  }
}
